import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/es';
import axios from 'axios';
import './Slider.css';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const API_URL = 'https://radioital.com/api/public/api/noticias';

const Noticias = () => {
  const [news, setNews] = useState(null);
  //shuffle(slides);
  
  useEffect(() => {
    axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((res) => setNews(res.data.data));

    new Swiper('.sliderN', {
      autoplay:{
          delay: 7500,
          pauseOnMouseEnter: true,
          disableOnInteraction: true,
      },
      modules:[Autoplay, Pagination, Navigation, Scrollbar],
      direction: 'horizontal',
      loop: true,
      spaceBetween: 10,
      slidesPerView: 1,
      breakpoints: {
          // when window width is >= 768px
          768: {
            slidesPerView: 1,
          }
      },
      scrollbar: {
          dragClass: 'swiper-scrollbar-dragN',
          el: '.swiper-scrollbarN',
          draggable: true,
      },
      navigation: {
        nextEl: '.swiper-button-nextN',
        prevEl: '.swiper-button-prevN',
      },
    });
  }, []);
  if(news){
    return (
      <div className="sliderN swiper">
        <div className="swiper-wrapper">
          {news.map((sld, indexq) => (
              <div className="swiper-slide" key={indexq}>
                  <h3>{sld.titulo_ntca}</h3>
                  <div className='content-slider'>
                    <img alt={sld.titulo_ntca} src={'/news/' + sld.imgn_ntca} />
                  </div>
                  <p className='body-news'>{sld.cntnd_ntca.substr(0, 100)}</p>
                  <a className='btn_cntct' rel="noreferrer" href={sld.link_ntca} target='_blank'>Leer articulo</a>
              </div>
          ))}
        </div>
        <div className="swiper-button-prevN"></div>
        <div className="swiper-button-nextN"></div>
        <div className="swiper-scrollbarN"></div>
      </div>
    );
  }
};

export default Noticias;
